import React from "react";

import {
  FaEye,
  FaUserMinus,
  FaUserPlus,
  FaUsers,
} from "react-icons/fa";

import ConvocationActionButton from "../ui/ConvocationActionButton";

export default function ConvocationActions({
  event,
  onRegister,
  onRegisterByGroup,
  onUnregister,
  onView,
}) {
  return (
    <div className="grid grid-cols-2 gap-2 sm:flex sm:flex-wrap">
      <ConvocationActionButton
        icon={<FaUserPlus />}
        label="Inscription"
        title="Convoquer un acteur"
        variant="primary"
        onClick={() => onRegister(event.id)}
      />

      <ConvocationActionButton
        icon={<FaUsers />}
        label="Groupes"
        title="Convoquer un ou plusieurs groupes"
        variant="indigo"
        onClick={() => onRegisterByGroup(event.id)}
      />

      <ConvocationActionButton
        icon={<FaUserMinus />}
        label="Désinscrire"
        title="Gérer les désinscriptions"
        variant="warning"
        onClick={() => onUnregister(event.id)}
      />

      <ConvocationActionButton
        icon={<FaEye />}
        label="Inscrits"
        title="Voir les acteurs inscrits"
        variant="neutral"
        onClick={() => onView(event.id)}
      />
    </div>
  );
}